import React from "react";
import { Navigate, Route, Routes } from "react-router";
import { MainIndex } from "../../../presentation/main/MainIndex";
import { HomeIndex } from "../../../presentation/pages/home/HomeIndex";
import { AnimatePresence } from "framer-motion";
import About from "../../../presentation/pages/about/About";

export const AppRoutes = () => {
  return (
    <AnimatePresence mode="wait">
      <Routes>
        {/* Main */}
        <Route path="/" element={<MainIndex />}>
          <Route index element={<Navigate replace to="home" />} />
          <Route path="home" element={<HomeIndex />} />
          <Route path="about" element={<About />} />
        </Route>
        {/* Not found */}
        <Route path="*"> Page not found! 🧐</Route>
      </Routes>
    </AnimatePresence>
  );
};
